import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import { AppDispatch } from '@Store';
import * as Yup from 'yup';

/* ----------------------------- OPTIONS ----------------------------- */

export const UpsPayorOptions: DropdownOptionType[] = [
  {
    value: 'SENDER',
    display: 'Sender',
  },
  {
    value: 'RECIPIENT',
    display: 'Recipient',
  },
  {
    value: 'THIRD_PARTY',
    display: 'Third Party',
  },
];

export const UpsServiceCodeOptions: DropdownOptionType[] = [
  {
    value: '01',
    display: 'UPS Next Day Air',
  },
  {
    value: '02',
    display: 'UPS 2nd Day Air',
  },
  {
    value: '03',
    display: 'UPS Ground',
  },
  {
    value: '07',
    display: 'UPS Express',
  },
  {
    value: '08',
    display: 'UPS Expedited',
  },
  {
    value: '11',
    display: 'UPS Standard',
  },
  {
    value: '12',
    display: 'UPS 3 Day Select',
  },
  {
    value: '65',
    display: 'UPS Express Saver',
  },
];

export const UpsPackagingCodeOptions: DropdownOptionType[] = [
  {
    value: '01',
    display: 'UPS Letter',
  },
  {
    value: '02',
    display: 'Customer Supplied Package',
  },
  {
    value: '03',
    display: 'Tube',
  },
  {
    value: '04',
    display: 'PAK',
  },
  {
    value: '21',
    display: 'Express Box',
  },
  {
    value: '24',
    display: '25KG Box',
  },
  {
    value: '25',
    display: '10KG Box',
  },
];

export const UpsReasonForExportOptions: DropdownOptionType[] = [
  {
    value: 'SALE',
    display: 'Sale',
  },
  {
    value: 'GIFT',
    display: 'Gift',
  },
  {
    value: 'SAMPLE',
    display: 'Sample',
  },
  {
    value: 'RETURN',
    display: 'Return',
  },
  {
    value: 'REPAIR',
    display: 'Repair',
  },
  {
    value: 'INTERCOMPANYDATA',
    display: 'Intercompany Data',
  },
];

/* --------------------------- INITIAL VALUES --------------------------- */

export interface upsInformationSchema {
  csp: string;
  type: string;
  accountNo: string;
  serviceCode: string;
  packagingCode: string;
  description: string;
  payor: string;
  ReasonforExport: string;
  awbShowToUser: boolean;
}

export const upsInitialValues: upsInformationSchema = {
  csp: 'movin_ups',
  type: '',
  accountNo: '',
  serviceCode: '',
  packagingCode: '',
  description: '',
  payor: '',
  ReasonforExport: '',
  awbShowToUser: true,
};

/* ----------------------------- VALIDATION ----------------------------- */

export const upsInformationValidation = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  accountNo: Yup.mixed()
    .test('is-valid', 'Account is required', (value: any) => {
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return true;
      return !!value;
    })
    .required('Account is required'),
  serviceCode: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Service Code is required'),
  packagingCode: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Packaging Code is required'),
  description: Yup.string().required('Description is required'),
  payor: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Payor is required'),
  ReasonforExport: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Reason for Export is required'),
});

/* ------------------------------- FORWARD ------------------------------- */

export const onForward = ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
}: {
  values: upsInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
}) => {
  const body = {
    ...JSON.parse(JSON.stringify(values)),
  };

  body.csp = 'movin_ups';

  for (const key in body) {
    if (body[key]) {
      if (key === 'accountNo') {
        body[key] = body[key]?.split('-')?.[0];
      }
    }
  }

  dispatch(
    postFedExDetails({
      shipmentNumber: `${shipmentNumber}`,
      body,
      date: null,
      nextFunc,
    }),
  );
};
